export default __webpack_public_path__ + "static/media/bIcon2.a689eca1.png";